export const STORED_COMPANY_ID_KEY = 'storedCompanyId'
